import React, { memo } from 'react';

const GeneralImageRender = props => <img {...props} />;

export default memo(GeneralImageRender);
